import { Layout } from 'antd'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { getDashPatientDetails, getDashPatientDetailsLoading } from '../actions/dashboardActions'

import SideBar from '../Views/SideBar'
import Bookings from '../Views/Bookings/Bookings'
import { Content } from 'antd/lib/layout/layout'
import CreateBooking from '../Views/Bookings/CreateBooking'
import { upload_patient_insurance, upload_patient_insurance_loading, upload_patient_report, upload_patient_report_loading } from '../actions/bookingActions'
import Home from './Home'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { whoami, whoamiLoading } from '../actions/authActions'
import GlobalLoading from './GlobalLoading'
import InitialLoading from './InitialLoading'
import SingleBooking from '../Views/Bookings/SingleBooking'
import Settings from '../Views/Settings'
import HospitalDetailsModal from '../Views/HospitalDetailsModal'
import FinalBill from '../Components/FinalBillComponent'
import HospitalDetails from '../Views/HospitalDetails'
import ResetPassword from '../Views/ResetPassword'
import Hims from '../Views/HIMS/Hims'
import TermsConditionsModal from '../Components/TermsConditionsModal'

function Dashboard(props) {

  // console.warn("dash PROPS:: ",props);
  const [termsChecked, setTermsChecked] = useState(false);

  const history = useHistory();

  const [loading,setLoading]=useState(false);
  const [hospitalData, setHospitalData] = useState(false)
  const [platformSubscriptionFee, setPlatformSubscriptionFee]=useState(0);
  const [representativeName, setRepresentativeName]=useState('');
  const [representativeDesignation, setRepresentativeDesignation]=useState('');
  const [visibleModal, setVisibleModal] = useState('termsAndConditions')

  const [activeSideKey, setActiveSideKey] = useState('4')

  useEffect(()=>{
    props.whoami();
  },[])

  useEffect(() => {
    if (props.whoamiRet) {
      if (props.whoamiRet.success) {
        setHospitalData(props.whoamiRet.user)
        setTermsChecked(props.whoamiRet.user.termsChecked || false)
        setPlatformSubscriptionFee(props.whoamiRet.user.platformFee || 0);
        setRepresentativeName(props.whoamiRet.user.representativeName || '');
        setRepresentativeDesignation(props.whoamiRet.user.representativeDesignation || '');
        props.whoamiLoading();
        // console.log("HERE IN SUCESS",props.whoamiRet);
      } else {
        // console.log("HERE IN ELSE BLOCK",props.whoamiRet);
        history.push('/auth')
      }
    }
    
  }, [props.whoamiRet]);

  useEffect(()=>{
    setLoading(props.whoamiLoadingFlag);
  },[props.whoamiLoadingFlag])

  useEffect(() => {
    scrollToTop()
  }, [])

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    })
  }

  if(loading) return <InitialLoading />

  return (
    <>
      <Layout>
        <SideBar activeKey={activeSideKey} />

        <Layout
          //  style={{ padding: '0 24px 24px' }}
          style={{ marginLeft: '75px' }}
        >
          <Content
            className="site-layout-background"
            style={{
              // padding: 12,
              margin: 0,
              minHeight: 280,
            }}
          >
            {!hospitalData.basicDetailUpdates && visibleModal==='termsAndConditions' && <TermsConditionsModal
                termsChecked={termsChecked}
                setTermsChecked={setTermsChecked}
                platformSubscriptonFee={platformSubscriptionFee}
                // setPlatformSubscriptionFee={setPlatformSubscriptionFee}
                representativeName={representativeName}
                setRepresentativeName={setRepresentativeName}
                representativeDesignation={representativeDesignation}
                setRepresentativeDesignation={setRepresentativeDesignation}
                hospitalData={hospitalData} 
                setVisibleModal={setVisibleModal}
              />}
            {!hospitalData.basicDetailUpdates && visibleModal==='basicDetails' && <HospitalDetailsModal hospitalData={hospitalData} representativeName={representativeName} representativeDesignation={representativeDesignation} termsChecked={termsChecked}/>}
            <div id="dashboard_content">
              {window.location.pathname === "/dashboard" && <Home setActiveSideKey={setActiveSideKey} location={props.location} />}
              {window.location.pathname === "/dashboard/booking-details" && <Bookings setActiveSideKey={setActiveSideKey} location={props.location} />}
              {window.location.pathname === "/dashboard/booking/booking-details" && <SingleBooking 
                location={props.location}

                setActiveSideKey={setActiveSideKey}

                upload_patient_report={props.upload_patient_report}
                upload_patient_report_ret={props.bookingStore.upload_patient_report_ret}
                upload_patient_report_loading={props.upload_patient_report_loading}
                upload_patient_report_loading_flag={props.bookingStore.upload_patient_report_loading}

              />}
              {window.location.pathname.startsWith('/dashboard/final-bill') && <FinalBill/>}
              {window.location.pathname === "/dashboard/create-booking" && <CreateBooking
                location={props.location}

                setActiveSideKey={setActiveSideKey} 
                
                upload_patient_report={props.upload_patient_report}
                upload_patient_report_ret={props.bookingStore.upload_patient_report_ret}
                upload_patient_report_loading={props.upload_patient_report_loading}
                upload_patient_report_loading_flag={props.bookingStore.upload_patient_report_loading}

                upload_patient_insurance={props.upload_patient_insurance}
                upload_patient_insurance_ret={props.bookingStore.upload_patient_insurance_ret}
                upload_patient_insurance_loading={props.upload_patient_insurance_loading}
                upload_patient_insurance_loading_flag={props.bookingStore.upload_patient_insurance_loading}
              />}
              {window.location.pathname === "/dashboard/hims" && <Hims
                location={props.location}
                setActiveSideKey={setActiveSideKey} 
              />}
              {/* {window.location.pathname === '/dashboard/settings' && <Settings location={props.location} setActiveSideKey={setActiveSideKey} />} */}

              {window.location.pathname === '/dashboard/hospital-details' && <HospitalDetails location={props.location} setActiveSideKey={setActiveSideKey} />}

              {window.location.pathname === '/dashboard/reset-password' && <ResetPassword location={props.location} setActiveSideKey={setActiveSideKey} />}
            </div>
          </Content>
        </Layout>
      </Layout>
    </>
  )
}

const mapStateToProps = (state) => ({
  dashboardStore: state.dashboardStore,
  bookingStore: state.bookingStore,
  getDashPatientDetailsRet: state.dashboardStore.getDashPatientDetailsRet,
  getDashPatientDetailsLoadingFlag: state.dashboardStore.getDashPatientDetailsLoading,
  whoamiRet: state.authStore.whoamiRet,
  whoamiLoadingFlag: state.authStore.loginLoading,
});

export default connect(mapStateToProps, {
  whoami,
  whoamiLoading,
  getDashPatientDetails,
  getDashPatientDetailsLoading,
  upload_patient_insurance,
  upload_patient_insurance_loading,
  upload_patient_report,
  upload_patient_report_loading
})(Dashboard);